var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "create-task-form" } }, [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "input title-input" },
        [
          _c("div", { staticClass: "label" }, [
            _vm._v(_vm._s(_vm.$t("task.title"))),
          ]),
          _vm._v(" "),
          _c("a-input", {
            staticClass: "classic-new-input",
            attrs: { placeholder: _vm.$t("task.taskNumber") },
            model: {
              value: _vm.form.title,
              callback: function ($$v) {
                _vm.$set(_vm.form, "title", $$v)
              },
              expression: "form.title",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "input priority-input" },
        [
          _c("div", { staticClass: "label" }, [
            _vm._v(_vm._s(_vm.$t("task.priority"))),
          ]),
          _vm._v(" "),
          _c("a-select", {
            staticClass: "classic-new-select",
            attrs: { options: _vm.options },
            model: {
              value: _vm.form.priority,
              callback: function ($$v) {
                _vm.$set(_vm.form, "priority", $$v)
              },
              expression: "form.priority",
            },
          }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "row" },
      [
        _c("quill-editor", {
          staticClass: "quill-editor",
          staticStyle: { "max-height": "20%", width: "100%" },
          attrs: {
            options: _vm.editorOption,
            placeholder: _vm.$t("message.taskDescription"),
          },
          on: {
            change: function ($event) {
              return _vm.onEditorChange($event)
            },
          },
          model: {
            value: _vm.form.description,
            callback: function ($$v) {
              _vm.$set(_vm.form, "description", $$v)
            },
            expression: "form.description",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "checklist-data" }, [
        _vm.form.checklist.length > 0
          ? _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "align-items": "center",
                  gap: "20px",
                },
              },
              [
                _c(
                  "div",
                  {
                    staticStyle: {
                      "font-weight": "bold",
                      "font-size": "16px",
                      "margin-right": "20px",
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("auto.checklist")))]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticStyle: { width: "200px" } },
                  [
                    _c("a-progress", {
                      attrs: {
                        "stroke-color": {
                          "0%": "ec4b1d",
                          "100%": "ec4b1d",
                        },
                        percent:
                          (100 / _vm.form.checklist.length) *
                          _vm.form.checklist.filter(function (c) {
                            return c.isCompleted
                          }).length,
                        "show-info": false,
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticStyle: { width: "200px" } }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(
                        _vm.$t("task.completedOfCheck", {
                          total: _vm.form.checklist.length,
                          completed: _vm.form.checklist.filter(function (c) {
                            return c.isCompleted
                          }).length,
                        })
                      ) +
                      "\n                "
                  ),
                ]),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            staticStyle: {
              "margin-top": "10px",
              display: "flex",
              gap: "10px",
              "flex-direction": "column",
            },
          },
          _vm._l(_vm.form.checklist, function (checkbox, index) {
            return _c(
              "div",
              {
                key: index,
                staticStyle: {
                  display: "flex",
                  "align-items": "center",
                  "justify-content": "flex-start",
                  "user-select": "none",
                },
              },
              [
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "align-items": "center",
                      gap: "10px",
                    },
                  },
                  [
                    _c("a-checkbox", {
                      staticClass: "kanban-checkbox large",
                      model: {
                        value: checkbox.isCompleted,
                        callback: function ($$v) {
                          _vm.$set(checkbox, "isCompleted", $$v)
                        },
                        expression: "checkbox.isCompleted",
                      },
                    }),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: checkbox.title,
                          expression: "checkbox.title",
                        },
                      ],
                      staticStyle: {
                        width: "300px",
                        border: "none",
                        outline: "none",
                        background: "#f1f1f1",
                        "border-radius": "4px",
                        padding: "3px 10px",
                      },
                      domProps: { value: checkbox.title },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(checkbox, "title", $event.target.value)
                        },
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "material-icons",
                    on: {
                      click: function ($event) {
                        return _vm.deleteCheckbox(index)
                      },
                    },
                  },
                  [_vm._v("close")]
                ),
              ]
            )
          }),
          0
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticStyle: {
              "margin-top": "10px",
              color: "#ec4b1d",
              "font-weight": "bold",
              cursor: "pointer",
            },
            on: { click: _vm.addNewCheckBox },
          },
          [
            _vm._v(
              "\n                " +
                _vm._s(
                  !_vm.form.checklist.length
                    ? this.$t("task.newCheckList")
                    : this.$t("task.add")
                ) +
                "\n            "
            ),
          ]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "attach-files" }, [
        _c("div", { staticClass: "text" }, [
          _c("div", { staticClass: "material-icons" }, [_vm._v("attachment")]),
          _vm._v(" "),
          _c("div", [_vm._v(_vm._s(_vm.$t("task.attachFiles")))]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "logo" }, [_c("s3Logo")], 1),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "user-assigne" }, [
      _c("div", { staticClass: "input", staticStyle: { width: "100%" } }, [
        _c("div", { staticClass: "label" }, [
          _vm._v(_vm._s(_vm.$t("task.assignee"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "user-assigne-container" },
          [
            _c("a-select", {
              staticClass: "select-multiple",
              attrs: { mode: "multiple", options: _vm.users },
              model: {
                value: _vm.form.assigneeIds,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "assigneeIds", $$v)
                },
                expression: "form.assigneeIds",
              },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "assigne-user-options" }, [
              _c(
                "div",
                {
                  staticClass: "assigne-option",
                  on: {
                    click: function ($event) {
                      return _vm.openAssigne("owner")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("task.owner")))]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "assigne-option",
                  on: {
                    click: function ($event) {
                      return _vm.openAssigne("collaborators")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("task.collaborators")))]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "assigne-option",
                  on: {
                    click: function ($event) {
                      return _vm.openAssigne("followers")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("task.followers")))]
              ),
            ]),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "input user-assigne-owner",
          staticStyle: { width: "100%" },
          style: { height: _vm.assigneOptions["owner"] ? "95px" : "0px" },
        },
        [
          _c("div", { staticClass: "row-bracket" }),
          _vm._v(" "),
          _c("div", { staticClass: "label" }, [
            _vm._v(_vm._s(_vm.$t("task.owner"))),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "user-assigne-container" },
            [
              _c("a-select", {
                staticClass: "select-multiple",
                attrs: { options: _vm.users },
                model: {
                  value: _vm.form.ownerId,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "ownerId", $$v)
                  },
                  expression: "form.ownerId",
                },
              }),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "input user-assigne-collaborators",
          staticStyle: { width: "100%" },
          style: {
            height: _vm.assigneOptions["collaborators"] ? "95px" : "0px",
          },
        },
        [
          _c("div", { staticClass: "row-bracket" }),
          _vm._v(" "),
          _c("div", { staticClass: "label" }, [
            _vm._v(_vm._s(_vm.$t("task.collaborators"))),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "user-assigne-container" },
            [
              _c("a-select", {
                staticClass: "select-multiple",
                attrs: { mode: "multiple", options: _vm.users },
                model: {
                  value: _vm.form.collaboratorIds,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "collaboratorIds", $$v)
                  },
                  expression: "form.collaboratorIds",
                },
              }),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "input user-assigne-followers",
          staticStyle: { width: "100%" },
          style: { height: _vm.assigneOptions["followers"] ? "95px" : "0px" },
        },
        [
          _c("div", { staticClass: "row-bracket" }),
          _vm._v(" "),
          _c("div", { staticClass: "label" }, [
            _vm._v(_vm._s(_vm.$t("task.followers"))),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "user-assigne-container" },
            [
              _c("a-select", {
                staticClass: "select-multiple",
                attrs: { mode: "multiple", options: _vm.users },
                model: {
                  value: _vm.form.followerIds,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "followerIds", $$v)
                  },
                  expression: "form.followerIds",
                },
              }),
            ],
            1
          ),
        ]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "input" }, [
        _c("div", { staticClass: "label" }, [
          _vm._v(_vm._s(_vm.$t("task.startDate"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          [
            _c("a-date-picker", {
              attrs: { dropdownClassName: "task-date-picker" },
              model: {
                value: _vm.form.startDate,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "startDate", $$v)
                },
                expression: "form.startDate",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "input" }, [
        _c("div", { staticClass: "label" }, [
          _vm._v(_vm._s(_vm.$t("task.endDate"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          [
            _c("a-date-picker", {
              attrs: { dropdownClassName: "task-date-picker" },
              model: {
                value: _vm.form.endDate,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "endDate", $$v)
                },
                expression: "form.endDate",
              },
            }),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row-bracket" }),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "checklist-data" }, [
        _vm.form.subtasks.filter(function (c) {
          return c.isCompleted && !c.isExits
        }).length > 0
          ? _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "align-items": "center",
                  gap: "20px",
                },
              },
              [
                _c(
                  "div",
                  {
                    staticStyle: {
                      "font-weight": "bold",
                      "font-size": "16px",
                      "margin-right": "20px",
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("auto.subtasks")))]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticStyle: { width: "200px" } },
                  [
                    _c("a-progress", {
                      attrs: {
                        "stroke-color": {
                          "0%": "ec4b1d",
                          "100%": "ec4b1d",
                        },
                        percent:
                          (100 / _vm.form.subtasks.length) *
                          _vm.form.subtasks.filter(function (c) {
                            return c.isCompleted
                          }).length,
                        "show-info": false,
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticStyle: { width: "200px" } }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(
                        _vm.$t("task.completedOfCheck", {
                          total: _vm.form.subtasks.filter(function (c) {
                            return c.isCompleted && !c.isExits
                          }).length,
                          completed: _vm.form.subtasks.filter(function (c) {
                            return c.isCompleted
                          }).length,
                        })
                      ) +
                      "\n                "
                  ),
                ]),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.form.subtasks.length > 0
          ? _c(
              "div",
              {
                staticStyle: {
                  "margin-top": "10px",
                  display: "flex",
                  gap: "10px",
                  "flex-direction": "column",
                },
              },
              _vm._l(_vm.form.subtasks, function (subtask, index) {
                return _c("div", [
                  !subtask.isExits
                    ? _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "align-items": "center",
                            "justify-content": "space-between",
                            "user-select": "none",
                            gap: "20px",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "align-items": "center",
                                gap: "10px",
                                width: "100%",
                              },
                            },
                            [
                              _c("a-checkbox", {
                                staticClass: "kanban-checkbox large",
                                model: {
                                  value: subtask.completed,
                                  callback: function ($$v) {
                                    _vm.$set(subtask, "completed", $$v)
                                  },
                                  expression: "subtask.completed",
                                },
                              }),
                              _vm._v(" "),
                              _c("a-input", {
                                staticClass: "classic-new-input",
                                attrs: {
                                  placeholder: _vm.$t("task.subtaskTitle"),
                                },
                                model: {
                                  value: subtask.title,
                                  callback: function ($$v) {
                                    _vm.$set(subtask, "title", $$v)
                                  },
                                  expression: "subtask.title",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticStyle: { width: "100%" } },
                            [
                              _c("a-select", {
                                staticClass: "select-multiple",
                                staticStyle: { width: "100%" },
                                attrs: {
                                  options: _vm.users,
                                  placeholder: _vm.$t("task.assignee"),
                                },
                                model: {
                                  value: subtask.assignees,
                                  callback: function ($$v) {
                                    _vm.$set(subtask, "assignees", $$v)
                                  },
                                  expression: "subtask.assignees",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "material-icons",
                              on: {
                                click: function ($event) {
                                  return _vm.deleteSubtask(index)
                                },
                              },
                            },
                            [_vm._v("close")]
                          ),
                        ]
                      )
                    : _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "align-items": "center",
                            "justify-content": "space-between",
                            "user-select": "none",
                            gap: "20px",
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { width: "100%" } },
                            [
                              _c("a-select", {
                                staticClass: "select-multiple",
                                staticStyle: { width: "100%" },
                                attrs: {
                                  options: _vm.users,
                                  placeholder: _vm.$t("task.assignee"),
                                },
                                model: {
                                  value: subtask.taskId,
                                  callback: function ($$v) {
                                    _vm.$set(subtask, "taskId", $$v)
                                  },
                                  expression: "subtask.taskId",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "material-icons",
                              on: {
                                click: function ($event) {
                                  return _vm.deleteSubtask(index)
                                },
                              },
                            },
                            [_vm._v("close")]
                          ),
                        ]
                      ),
                ])
              }),
              0
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            {
              staticStyle: {
                "margin-top": "10px",
                color: "#ec4b1d",
                "font-weight": "bold",
                cursor: "pointer",
              },
              on: {
                click: function ($event) {
                  return _vm.addNewSubtask(false)
                },
              },
            },
            [
              _vm._v(
                "\n                    " +
                  _vm._s("Add Subtasks") +
                  "\n                "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticStyle: {
                "margin-top": "10px",
                color: "#ec4b1d",
                "font-weight": "bold",
                cursor: "pointer",
              },
              on: {
                click: function ($event) {
                  return _vm.addNewSubtask(true)
                },
              },
            },
            [
              _vm._v(
                "\n                    " +
                  _vm._s("Add Exits Subtasks") +
                  "\n                "
              ),
            ]
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }